import { ProfileNav } from '../../../../components/profile/ProfileNav';

/** The rail's entries — each narrows the applicants; Appointment lists those whose appointment is recorded. */
export type ApplicantFilterKey = 'all' | 'shortlisted' | 'endorsed' | 'appointment';

/**
 * A posting's applicant FILTER RAIL (product calls, 20–21 Oct 2026) — All · Short Listed · Endorsed ·
 * Appointment, each with its count, the shared `<ProfileNav>` in a `w-56` aside at the panel's left edge.
 * ONE rail for both Applicants tabs, Deliberate's and Applicants' own, so the two cannot drift.
 *
 * Every entry past All reads a DELIBERATE value, so a caller draws this only for a reader holding
 * `deliberations.read`.
 */
export function ApplicantFilterRail({
  id,
  active,
  counts,
  onSelect,
}: {
  id: string;
  active: ApplicantFilterKey;
  /** Off the server's `shortlist` facet — undefined until the first page. */
  counts: Partial<Record<'all' | 'shortlisted' | 'endorsed' | 'appointed', number>>;
  onSelect: (key: ApplicantFilterKey) => void;
}) {
  return (
    <aside
      aria-label="Filter applicants"
      className="modern-scrollbar w-56 shrink-0 overflow-y-auto overflow-x-hidden border-r border-slate-200 bg-white"
    >
      <ProfileNav
        id={id}
        entries={[
          { key: 'all', label: 'All', count: counts.all },
          { key: 'shortlisted', label: 'Short Listed', count: counts.shortlisted },
          { key: 'endorsed', label: 'Endorsed', count: counts.endorsed },
          // The endorsed applicant whose APPOINTMENT is recorded — oath taking or assignment (22 Oct 2026).
          { key: 'appointment', label: 'Appointment', count: counts.appointed },
        ]}
        activeKey={active}
        onSelect={(key) => onSelect(key === 'shortlisted' || key === 'endorsed' || key === 'appointment' ? key : 'all')}
      />
    </aside>
  );
}
